import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Lightbulb, X } from 'lucide-react';
import { emailVorschlag } from '../lib/emailTypo';

const setzeWert = (el, v) => {
  Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(el, v);
  el.dispatchEvent(new Event('input', { bubbles: true }));
};
const istEmailFeld = (el) => el instanceof HTMLInputElement && el.type === 'email';

/** Globaler Tippfehler-Hinweis für alle <input type="email"> der App (blockiert nichts). */
export const EmailTypoHint = () => {
  const { t } = useTranslation();
  const [ziel, setZiel] = useState(null);
  const [vorschlag, setVorschlag] = useState(null);
  const [pos, setPos] = useState(null);
  const [verworfen, setVerworfen] = useState('');

  const messen = useCallback(() => {
    if (!ziel || !ziel.isConnected) { setPos(null); return; }
    const r = ziel.getBoundingClientRect();
    setPos(r.width && r.bottom > 0 && r.top < window.innerHeight ? { top: r.bottom + 4, left: Math.max(8, r.left), width: Math.min(Math.max(r.width, 240), window.innerWidth - 16) } : null);
  }, [ziel]);

  useEffect(() => {
    let timer;
    const pruefen = (e) => {
      if (!istEmailFeld(e.target)) return;
      const el = e.target;
      clearTimeout(timer);
      timer = setTimeout(() => { setZiel(el); setVorschlag(emailVorschlag(el.value)); }, e.type === 'input' ? 500 : 0);
    };
    document.addEventListener('input', pruefen, true);
    document.addEventListener('focusout', pruefen, true);
    return () => { clearTimeout(timer); document.removeEventListener('input', pruefen, true); document.removeEventListener('focusout', pruefen, true); };
  }, []);

  useEffect(() => {
    messen();
    window.addEventListener('scroll', messen, true);
    window.addEventListener('resize', messen);
    const iv = setInterval(messen, 700);
    return () => { window.removeEventListener('scroll', messen, true); window.removeEventListener('resize', messen); clearInterval(iv); };
  }, [messen, vorschlag]);

  if (!vorschlag || !pos || vorschlag === verworfen) return null;
  const uebernehmen = () => { setzeWert(ziel, vorschlag); setVorschlag(null); ziel.focus(); };
  return createPortal(
    <div className="fixed z-[1100] flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-300 text-amber-900 text-xs rounded-sm shadow-md animate-in fade-in slide-in-from-top-1 duration-200"
      style={{ top: pos.top, left: pos.left, maxWidth: pos.width }} role="status" data-testid="email-typo-hint" onMouseDown={(e) => e.preventDefault()}>
      <Lightbulb className="w-3.5 h-3.5 shrink-0 text-amber-600" />
      <span className="min-w-0 break-all">{t('emailTypo.meinten')}{' '}
        <button type="button" onClick={uebernehmen} className="font-semibold underline decoration-dotted underline-offset-2 hover:text-[#1B3A5C]" data-testid="email-typo-apply">{vorschlag}</button>?
      </span>
      <button type="button" onClick={() => setVerworfen(vorschlag)} className="ml-auto shrink-0 text-amber-700 hover:text-amber-900" aria-label={t('emailTypo.ignorieren')} title={t('emailTypo.ignorieren')} data-testid="email-typo-dismiss">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>,
    document.body,
  );
};
